var Program = function () {
    $(document).ready(function(){
        $(".media.img").wrap($(".field-content"));
    });
};

module.exports = Program;